/**
 * Support Drawer Header Component
 * Header with title and close button
 */

import Icon from '@mdi/react';
import { mdiClose, mdiHelpCircleOutline } from '@mdi/js';
import { useSupportDrawer } from '@stores';

const SupportDrawerHeader = ({ content }: { content: string }) => {
  const { closeDrawer } = useSupportDrawer();

  return (
    <header className='support-drawer__header'>
      <div className='support-drawer__header-title'>
        <Icon path={mdiHelpCircleOutline} size={1} className='support-drawer__header-icon' aria-hidden='true' />
        <h2>{content}</h2>
      </div>
      <button type='button' className='support-drawer__close-btn' onClick={closeDrawer} aria-label='Close help drawer'>
        <Icon path={mdiClose} size={1} className='support-drawer__close-icon' aria-hidden='true' />
      </button>
    </header>
  );
};

export default SupportDrawerHeader;
